import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { LanguageCode } from "../../utils/translations";
import { HOME_COPY } from "./homeContent";
import SectionHeading from "./SectionHeading";
import ScrollRow from "./ScrollRow";
import { HOME_THEME, sectionPadding } from "./theme";

interface PlaybooksProps {
  lang: LanguageCode;
}

const Playbooks: React.FC<PlaybooksProps> = ({ lang }) => {
  const { eyebrow, title, subtitle, items, linkLabel } =
    HOME_COPY[lang].playbooksSection;

  return (
    <section style={{ padding: sectionPadding, background: HOME_THEME.surfaceAlt }}>
      <ScrollRow
        ariaLabel="Automation playbooks"
        header={
          <SectionHeading
            align="center"
            noMargin
            eyebrow={eyebrow}
            title={title}
            subtitle={subtitle}
          />
        }
      >
        {items.map((p) => (
          <div
            key={p.title}
            style={{
              flex: "0 0 auto",
              width: "300px",
              scrollSnapAlign: "start",
              display: "flex",
              flexDirection: "column",
              background: HOME_THEME.surface,
              border: `1px solid ${HOME_THEME.border}`,
              borderRadius: "14px",
              padding: "18px",
              boxSizing: "border-box",
            }}
          >
            <h3
              style={{
                margin: "0 0 14px 0",
                fontSize: "1.08rem",
                fontWeight: 700,
                color: HOME_THEME.heroHeading,
              }}
            >
              {p.title}
            </h3>

            <ol
              style={{
                listStyle: "none",
                margin: "0 0 18px 0",
                padding: 0,
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                flex: 1,
              }}
            >
              {p.steps.map((step, i) => (
                <li
                  key={step}
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "flex-start",
                    fontSize: "0.88rem",
                    color: HOME_THEME.inkSoft,
                    lineHeight: 1.45,
                  }}
                >
                  <span
                    style={{
                      flexShrink: 0,
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      background: HOME_THEME.primarySoft,
                      color: HOME_THEME.primaryDark,
                      fontSize: "0.7rem",
                      fontWeight: 800,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {i + 1}
                  </span>
                  {step}
                </li>
              ))}
            </ol>

            <Link
              to={p.to}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                color: HOME_THEME.primary,
                fontWeight: 700,
                fontSize: "0.88rem",
                textDecoration: "none",
              }}
            >
              {linkLabel} <ArrowRight size={15} />
            </Link>
          </div>
        ))}
      </ScrollRow>
    </section>
  );
};

export default Playbooks;
